import { _x } from '@safe-wordpress/i18n';

export const daysList = {
	Monday: _x( 'Monday', 'text', 'nelio-ab-testing' ),
	Tuesday: _x( 'Tuesday', 'text', 'nelio-ab-testing' ),
	Wednesday: _x( 'Wednesday', 'text', 'nelio-ab-testing' ),
	Thursday: _x( 'Thursday', 'text', 'nelio-ab-testing' ),
	Friday: _x( 'Friday', 'text', 'nelio-ab-testing' ),
	Saturday: _x( 'Saturday', 'text', 'nelio-ab-testing' ),
	Sunday: _x( 'Sunday', 'text', 'nelio-ab-testing' ),
};
